import React, { useRef, useState } from 'react';
import ApiService from '../../../services/apiService';
import { toast } from 'react-toastify';
import userManagement from '../../../services/userManagement';
import localStorage from 'redux-persist/es/storage';

const PasscodePopup = ({ onSubmit, onClose }) => {
  const [error, setError] = useState('');
  const [passcode, setPasscode] = useState(['', '', '', '']);
  const refs = [useRef(), useRef(), useRef(), useRef()];

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      let Token = await localStorage.getItem('Token');
      let userId = await userManagement.getUserId(Token);
      const otpString = passcode.join('');

      let param = `?PinCode=${otpString}&UserId=${userId}`;
      const apiService = new ApiService();
      const response = await apiService.getApiParamater('VERIFY_PASS', param);

      if (response.data.statusCode === 200) {
        onSubmit(true);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      setError('Error authenticating passcode. Please try again later.');
      console.error('API error:', error);
    }
  };

  const handleOtpChange = (index, value) => {
    if (isNaN(value)) return;

    const updated = [...passcode];
    updated[index] = value.slice(-1);
    setPasscode(updated);

    if (value !== '' && index < 3) {
      refs[index + 1].current.focus();
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.popup}>
        {/* Close Button */}
        <button onClick={onClose} style={styles.closeButton}>
          ✖
        </button>

        <h4>Enter 4 Digit Passcode</h4>
        {error && <p style={{ color: 'red' }}>{error}</p>}

        <form onSubmit={handleSubmit}>
          <div className="passbx">
            <div className="d-flex">
              {[0, 1, 2, 3].map((index) => (
                <input
                  key={index}
                  type="number"
                  maxLength={1}
                  value={passcode[index]}
                  onChange={(e) => handleOtpChange(index, e.target.value)}
                  ref={refs[index]}
                  className="otpbx"
                />
              ))}
            </div>
          </div>
          <button type="submit" className="addItem-btn w-100" style={styles.button}>
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  },
  popup: {
    position: 'relative',
    backgroundColor: 'white',
    padding: '60px 40px',
    borderRadius: '8px',
    textAlign: 'center',
    width: '520px',
  },
  closeButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    background: 'transparent',
    border: 'none',
    fontSize: '22px',
    cursor: 'pointer',
    color: '#333',
  },
  button: {
    padding: '10px 20px',
  },
};

export default PasscodePopup;
